import { Grid, GridCell, GridCellProps, GridColumn, GridNoRecords, GridRowClickEvent } from "@progress/kendo-react-grid";
import CustomModal from "../../commons/modals/CustomModal";
import { useAddVehiculeMutation, useGetVehiculesQuery } from "../../redux/api/cache";
import { Agence } from "../../models/Agence";
import { Magasin } from "../../models/Magasin";
import LoaderContainer from "../../commons/container/LoaderContainer";
import { vehiculesColumns } from "./vehiculesColumns";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import GarageCell from "./cells/GarageCell";
import { dateToBdFormat } from "../../commons/helpers/Dates";

interface AddVehiculeModalProps {
    setShowAddModalVehicule: React.Dispatch<React.SetStateAction<boolean>>;
    agence: Agence;
    magasin: Magasin;
    date: Date;
}

export default function AddVehiculeModal(props: AddVehiculeModalProps) {
    const minGridWidth = useRef<number>(0);
    const currentGridWidth = useRef<number>(0);
    const grid = useRef<any>(null);
    const [applyMinWidth, setApplyMinWidth] = useState(false);
    const [gridCurrent, setGridCurrent] = useState(0);
    const { data: vehicules, isLoading: isVehiculesLoading, isFetching: isVehiculesFetching } = useGetVehiculesQuery({ agence: props.agence.agence_cd, mag_num: props.magasin.mag_num }, { skip: props.magasin.mag_num === -1 || !props.agence.agence_cd, refetchOnMountOrArgChange: true });
    const [addVehicule] = useAddVehiculeMutation();
    const customCells = useMemo(() => new Map<string, (gridProps: GridCellProps) => JSX.Element>([
        ["garageCell", GarageCell],
    ]), []);

    const handleResize = () => {
        currentGridWidth.current = 0;
        if (grid.current.offsetWidth < minGridWidth.current && !applyMinWidth)
            setApplyMinWidth(true);
        else if (grid.current.offsetWidth > minGridWidth.current)
            setApplyMinWidth(false);
        setGridCurrent(grid.current.offsetWidth);
    }

    useEffect(() => {
        minGridWidth.current = 0;
        currentGridWidth.current = 0;
        grid.current = document.querySelector('.k-grid');
        window.addEventListener('resize', handleResize);
        vehiculesColumns.forEach((item: any) => minGridWidth.current = item.minWidth !== undefined ? minGridWidth.current + item.minWidth : minGridWidth.current);
        setGridCurrent(grid.current.offsetWidth);
        setApplyMinWidth(grid.current.offsetWidth < minGridWidth.current);
        handleResize();
    }, [])

    const setWidth = useCallback((minWidth: number, isLast: boolean) => {
        let width = applyMinWidth ? minWidth :
            isLast ? ((gridCurrent > currentGridWidth.current && gridCurrent - currentGridWidth.current - 24 > minWidth) ? gridCurrent - currentGridWidth.current - 24 : minWidth) : minWidth;
        currentGridWidth.current += width;
        return width;
    }, [gridCurrent, applyMinWidth]);

    const handleRowClick = async (e: GridRowClickEvent) => {
        await addVehicule({ agence: props.agence.agence_cd, mag_num: props.magasin.mag_num, body: e.dataItem, date: dateToBdFormat(props.date) });
        props.setShowAddModalVehicule(false);
    };

    const gridColumns = useMemo(() => {
        return vehiculesColumns.map((c, i) => <GridColumn title={c.title} field={c.field} key={i} cell={c.cell ? customCells.get(c.cell) : GridCell} width={setWidth(c.minWidth, i === vehiculesColumns.length - 1)} minResizableWidth={c.minWidth}></GridColumn>)
    }, [customCells, setWidth]);

    return <CustomModal title="Choix du véhicule" onClose={() => props.setShowAddModalVehicule(false)} width={"80vw"} height={"80vh"} body={<>
        {!isVehiculesFetching && !isVehiculesLoading && (<Grid className="k-h-full" resizable={true} reorderable={false} data={vehicules} onRowClick={handleRowClick}>
            {gridColumns}
            <GridNoRecords>
                <p>Aucune donnée à afficher</p>
            </GridNoRecords></Grid>)}
        {(isVehiculesFetching || isVehiculesLoading) && (<LoaderContainer />)}
    </>} />;
}